
export enum LanguageType {
  UserSelection = 0,
  FromAd = 1
}

export class UserLanguageTerm {

  public LanguageTermId: string;

  public UserUpnId: string;

  public LanguageType: LanguageType;

  constructor(opt?: Partial<UserLanguageTerm>) {
    Object.assign(this, opt);
  }
}
